import { useEffect, useRef } from 'react';
import { useHistory } from 'react-router-dom';
import toast from 'react-hot-toast';
import {
  useCreateFromDocumentProgress,
  CreateFromDocumentStatus,
} from './CreateFromDocumentProgressProvider';
import { ToastDuration } from '~/constants/toasts';

export default function CreateFromDocumentToastNotifier() {
  const progress = useCreateFromDocumentProgress();
  const history = useHistory();
  const prevStatusRef = useRef<CreateFromDocumentStatus | null>(null);

  useEffect(() => {
    const prev = prevStatusRef.current;
    const curr = progress?.status ?? null;
    prevStatusRef.current = curr;

    if (prev === curr) return;
    if (curr !== 'complete' && curr !== 'error') return;

    const result = progress?.result;

    if (curr === 'complete' && result) {
      let name: string;
      let dest: string;

      if (result.type === 'project') {
        name = result.projectName ?? 'New project';
        dest = `/project/${result.projectId}/worksheet`;
      } else if (result.type === 'portfolio') {
        name = result.portfolioName ?? 'New portfolio';
        dest = `/portfolio/${result.portfolioId}`;
      } else {
        return;
      }

      toast.success(
        (t) => (
          <div
            onClick={() => {
              toast.dismiss(t.id);
              progress?.dismiss();
              history.push(dest);
            }}
            style={{ cursor: 'pointer' }}
          >
            <strong>{name}</strong> created from document.
            <br />
            <small style={{ opacity: 0.7 }}>Click to view</small>
          </div>
        ),
        { duration: ToastDuration.LONG },
      );
    } else if (curr === 'error') {
      const message =
        result?.type === 'error' ? result.message : 'Import failed.';

      toast.error(
        (t) => (
          <div
            onClick={() => {
              toast.dismiss(t.id);
              history.push('/my-deals');
            }}
            style={{ cursor: 'pointer' }}
          >
            <strong>Document import failed</strong>
            {message && (
              <>
                <br />
                {message}
              </>
            )}
            <br />
            <small style={{ opacity: 0.7 }}>Click for details</small>
          </div>
        ),
        { duration: ToastDuration.LONG },
      );
    }
  }, [progress?.status, progress?.result, history]);

  return null;
}
